import React from "react"

import Footer from "../Home/Footer/Footer"
import "../Home/Home.css"

import Project from "./Project"


 export default function Homep(){
    return (
        <div className="home-container">
         
          <Project/>
          <Footer/>
          
        
        </div>
    )
 }